import React from "react";
import heroSectionBoard from "./images/hero-section-board-img.webp";
import boardSunil from "./images/board-sunil.webp";
import boardMeeta from "./images/board-meeta.webp";
import boardKalpataru from "./images/board-kalpataru.jpg";
import boardAnil from "./images/board-anil.webp";
import boardSundeep from "./images/board-sundeep.jpg";

import "./style.css";
import { useState } from "react";

const committees = [
  {
    name: "Audit Committee",
    members: [
      {
        name: "Ms. Meeta Makhan",
        position: "Chairperson",
        designation: "Independent Director",
      },
      {
        name: "Mr. Kalpataru Tripathy",
        position: "Member",
        designation: "Independent Director",
      },
      {
        name: "Mr. Anil Kumar Jha",
        position: "Member",
        designation: "Independent Director",
      },
      {
        name: "Mr. Sunil Sachdeva",
        position: "Member",
        designation: "Chairman and Managing Director",
      },
    ],
  },
  {
    name: "Nomination and Remuneration Committee (NRC)",
    members: [
      {
        name: "Ms. Meeta Makhan",
        position: "Chairperson",
        designation: "Independent Director",
      },
      {
        name: "Mr. Kalpataru Tripathy",
        position: "Member",
        designation: "Independent Director",
      },
      {
        name: "Mr. Anil Kumar Jha",
        position: "Member",
        designation: "Independent Director",
      },
      {
        name: "Mr. Sunil Sachdeva",
        position: "Member",
        designation: "Chairman and Managing Director",
      },
    ],
  },
  {
    name: "Corporate Social Responsibility (CSR) Committee",
    members: [
      {
        name: "Mr. Sunil Sachdeva",
        position: "Chairperson",
        designation: "Chairman and Managing Director",
      },
      {
        name: "Mr. Kalpataru Tripathy",
        position: "Member",
        designation: "Independent Director",
      },
      {
        name: "Mr. Anil Kumar Jha",
        position: "Member",
        designation: "Independent Director",
      },
    ],
  },
  {
    name: "IT Strategy Committee",
    members: [
      {
        name: "Ms. Meeta Makhan",
        position: "Chairperson",
        designation: "Independent Director",
      },
      {
        name: "Mr. Kalpataru Tripathy",
        position: "Member",
        designation: "Independent Director",
      },
      { name: "Mr. Saurabh Arora", position: "Member", designation: "CFO" },
      { name: "Mr. Kapil Tyagi", position: "Member", designation: "Head-IT" },
    ],
  },
  {
    name: "Risk Management Committee",
    members: [
      {
        name: "Mr. Sunil Sachdeva",
        position: "Chairperson",
        designation: "Chairman and Managing Director",
      },
      {
        name: "Mr. Anand Kumar Tripathi",
        position: "Member",
        designation: "Chief Operations Officer",
      },
      {
        name: "Mr. Saurabh Arora",
        position: "Member",
        designation: "Chief Financial Officer",
      },
    ],
  },
  {
    name: "Asset-Liability Management Committee",
    members: [
      {
        name: "Mr. Sunil Sachdeva",
        position: "Chairperson",
        designation: "Chairman and Managing Director",
      },
      {
        name: "Mr. Anand Kumar Tripathi",
        position: "Member",
        designation: "Chief Operations Officer",
      },
      {
        name: "Mr. Saurabh Arora",
        position: "Member",
        designation: "Chief Financial Officer",
      },
    ],
  },
  {
    name: "Borrowing Committee",
    members: [
      {
        name: "Mr. Sunil Sachdeva",
        position: "Chairperson",
        designation: "Chairman and Managing Director",
      },
      {
        name: "Ms. Meeta Makhan",
        position: "Member",
        designation: "Independent Director",
      },
      {
        name: "Mr. Saurabh Arora",
        position: "Member",
        designation: "Chief Financial Officer",
      },
    ],
  },
  {
    name: "Special Committee of the Board for Monitoring and Follow-up of cases of Frauds (SCBMF)",
    members: [
      {
        name: "Mr. Sunil Sachdeva",
        position: "Chairperson",
        designation: "Chairman and Managing Director",
      },
      {
        name: "Mr. Anand Kumar Tripathi",
        position: "Member",
        designation: "Chief Operations Officer",
      },
      {
        name: "Mr. Saurabh Arora",
        position: "Member",
        designation: "Chief Financial Officer",
      },
    ],
  },
];

function getInitials(name) {
  const cleaned = name.replace(/^(Mr\.|Ms\.|Mrs\.|Dr\.)\s*/i, "").trim();
  const parts = cleaned.split(/\s+/);
  const first = parts[0] ? parts[0][0] : "";
  const last = parts.length > 1 ? parts[parts.length - 1][0] : "";
  return (first + last).toUpperCase();
}

function Board() {
  const [fix, setFix] = useState(false);
  const [activeCommittee, setActiveCommittee] = useState(null);

  function setFixed() {
    if (window.scrollY >= 56) {
      setFix(true);
    } else {
      setFix(false);
    }
  }
  window.addEventListener("scroll", setFixed);

  return (
    <div>
      <div className={fix ? "main-wrapper fixed" : "main-wrapper"}>
        {/* <!-- *************** HERO SECTION STARTS *************** --> */}
        <section className="hero-section">
          <img src={heroSectionBoard} alt="" />
          <div className="hero-section-box">
            <div className="hero-section-text">
              <p>OUR BOARD</p>
            </div>
          </div>
        </section>

        {/* <!-- *************** BOARD SECTION STARTS *************** --> */}

        <section className="board-section">
          <div className="container">
            <h2 className="board-heading">Board of Directors</h2>
            <div className="person-card-wrapper">
              <div className="person-card">
                <img src={boardSunil} alt="" />
                <div className="person-card-text">
                  <h4>MR. SUNIL SACHDEVA</h4>
                  <p className="person-role">
                    Founder, Chairman and Managing Director
                  </p>
                  <p className="person-description">
                    Sunil Sachdeva is a seasoned entrepreneur with a diverse
                    business portfolio spanning healthcare, finance, real
                    estate, and technology. He is the co-founder and director of
                    Medanta, one of India’s largest multi-specialty hospitals{" "}
                    <i>(2400+ installed beds)</i> with five hospitals in Delhi,
                    Gurugram, Indore, Ranchi, Patna and Lucknow. In 2010, he
                    established SVCL with a clear mission to facilitate
                    financial inclusion for the enterprising rural women in
                    India. His unwavering vision, boundless energy, and
                    commitment to innovation have positioned him as a standout
                    leader, propelling SVCL's growth story forward. His
                    entrepreneurial journey has been instrumental in
                    transforming access to quality healthcare and promoting
                    financial inclusion in India.
                  </p>
                </div>
              </div>
              <div className="person-card">
                <img src={boardMeeta} alt="" />
                <div className="person-card-text">
                  <h4>MS. MEETA MAKHAN</h4>
                  <p className="person-role">INDEPENDENT DIRECTOR</p>
                  <p className="person-description">
                    Ms. Meeta Makhan, is Founder and Director of Doundo Services
                    Pvt Ltd, a sustainability solutions company, working with
                    emerging technologies for prevention of climate change,
                    converting public spaces into green in corporate buildings,
                    helping individuals have their own organic vegetable gardens
                    and promoting residential and corporate office rooftop
                    solar. She has wide range of experience in Corporate and
                    Investment Banking dealing with Large Indian Corporates,
                    Multinationals and Medium and Small Enterprise companies
                    across various regions in India.
                  </p>
                </div>
              </div>
              <div className="person-card">
                <img src={boardAnil} alt="" />
                <div className="person-card-text">
                  <h4>Mr. Anil Kumar Jha</h4>
                  <p className="person-role">INDEPENDENT DIRECTOR</p>
                  <p className="person-description">
                    Mr Anil Kumar Jha is B. Tech. in Mining from IIT(ISM),
                    Dhanbad and M. Tech. in Mine Planning & Design from
                    IIT(ISM), Dhanbad. He has three decades of experience under
                    his belt in mine planning, production, management
                    supervision direction and control of underground as well as
                    open cast coal mines. He began his career in coal mining
                    industry in 1983 in Central Coalfields Limited. He also
                    served as General Manager in Central Coalfields Limited. He
                    was Chairman & Managing Director of Coal India Limited
                    (CIL).
                  </p>
                </div>
              </div>
              <div className="person-card">
                <img src={boardKalpataru} alt="" />
                <div className="person-card-text">
                  <h4>MR. KALPATARU TRIPATHY</h4>
                  <p className="person-role">INDEPENDENT DIRECTOR</p>
                  <p className="person-description">
                    Kalpataru Tripathy is a corporate lawyer with close to 25
                    years of experience. He is a Chemistry (Hons.) graduate from
                    Utkal University, a law graduate from Delhi University, a PG
                    Diploma holder in International Business Law from Indian
                    Society of International Law, and has undertaken an
                    Executive Education (Management) from Judge Business School,
                    University of Cambridge.
                  </p>
                </div>
              </div>
              <div className="person-card">
                <img src={boardSundeep} alt="" />
                <div className="person-card-text">
                  <h4>Mr. Sundeep Kalsi</h4>
                  <p className="person-role">Non-Executive Director</p>
                  <p className="person-description">
                    Mr. Sundeep Kalsi is having almost 30 years of experience in
                    NBFC Companies, Healthcare Services, Development of
                    Infrastructure Services and Real Estates and Facility
                    Management within India and outside India. He carries
                    expertise in Marketing, Developing & Execution of Projects,
                    understanding of business affairs and structural risks with
                    ability to articulate and drive pragmatic solutions to
                    maximise business returns. He carries versatility of
                    experience with organisations of repute viz Ramsons Projects
                    Limited (NBFC), S A S Servizio Private Limited, S A S
                    Heights Private Limited, Dream Merchant Relators Private
                    Limited, Blessings Real Con Private Limited, SSS Services
                    Private Limited etc.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <!-- *************** COMMITTEES SECTION STARTS *************** --> */}

        <section className="committees-section">
          <div className="container">
            <h2 className="committees-heading">Committees</h2>
            <p className="committees-subheading">
              Click on a committee to view its members and their roles.
            </p>
            <div className="committee-grid">
              {committees.map((committee, index) => (
                <button
                  type="button"
                  key={index}
                  className="committee-card"
                  onClick={() => setActiveCommittee(committee)}
                >
                  <span className="committee-card-name">{committee.name}</span>
                  <span className="committee-card-meta">
                    {committee.members.length} members
                    <span className="committee-card-arrow">&#8594;</span>
                  </span>
                </button>
              ))}
            </div>
          </div>
        </section>
      </div>

      {/* <!-- *************** COMMITTEE MODAL *************** --> */}

      {activeCommittee && (
        <div
          className="committee-modal-overlay"
          onClick={() => setActiveCommittee(null)}
        >
          <div className="committee-modal" onClick={(e) => e.stopPropagation()}>
            <div className="committee-modal-header">
              <h3>{activeCommittee.name}</h3>
              <button
                type="button"
                className="committee-modal-close"
                aria-label="Close"
                onClick={() => setActiveCommittee(null)}
              >
                &times;
              </button>
            </div>
            <div className="committee-modal-body">
              <table className="committee-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Position</th>
                    <th>Designation</th>
                  </tr>
                </thead>
                <tbody>
                  {activeCommittee.members.map((member, i) => (
                    <tr key={i}>
                      <td>
                        <span className="committee-member">
                          <span className="committee-avatar">
                            {getInitials(member.name)}
                          </span>
                          <span>{member.name}</span>
                        </span>
                      </td>
                      <td>
                        <span
                          className={`committee-badge ${
                            member.position.toLowerCase() === "chairperson"
                              ? "committee-badge-chair"
                              : ""
                          }`}
                        >
                          {member.position}
                        </span>
                      </td>
                      <td>{member.designation}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Board;
